export const resizeSpotsArray = (spots: string[], newLength: number): string[] => {
  if (newLength <= spots.length) {
    return spots.slice(0, newLength);
  }

  const newSpots = Array.from({ length: newLength - spots.length }, (_, index) => String(spots.length + index + 1));

  return [...spots, ...newSpots];
};
